// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CSVImporter_ColumnDragCard {
  position: relative;
  z-index: 0;
  padding: 0.5em 0.75em;
  border-radius: 0.4em;
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
  cursor: default;
}
.CSVImporter_ColumnDragCard[data-draggable=true] {
  cursor: grab;
  touch-action: none;
}
.CSVImporter_ColumnDragCard[data-dummy=true] {
  border-radius: 0;
  background: #f0f0f0;
  box-shadow: none;
  opacity: 0.5;
  user-select: none;
}
.CSVImporter_ColumnDragCard[data-error=true] {
  background: rgba(192, 0, 0, 0.25);
  color: #202020;
}
.CSVImporter_ColumnDragCard[data-shadow=true] {
  background: #f0f0f0;
  box-shadow: none;
  color: rgba(32, 32, 32, 0.25);
}
.CSVImporter_ColumnDragCard[data-drop-indicator=true] {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  color: #000;
}
.CSVImporter_ColumnDragCard__cardHeader {
  margin-top: -0.25em;
  margin-right: -0.5em;
  margin-bottom: 0.25em;
  margin-left: -0.5em;
  height: 1.5em;
  font-weight: bold;
  color: #808080;
}
.CSVImporter_ColumnDragCard__cardHeader > b {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #f0f0f0;
  line-height: 1;
}
.CSVImporter_ColumnDragCard__cardHeader > var {
  display: block;
  margin-bottom: -1px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
.CSVImporter_ColumnDragCard__cardPaper[data-draggable=true]:hover .CSVImporter_ColumnDragCard__cardHeader, .CSVImporter_ColumnDragCard__cardPaper[data-dragged=true] .CSVImporter_ColumnDragCard__cardHeader {
  color: #000;
}
.CSVImporter_ColumnDragCard__cardValue {
  margin-top: 0.25em;
  overflow: hidden;
  line-height: 1.25em;
  font-size: 0.75em;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.CSVImporter_ColumnDragCard__cardValue[data-header=true] {
  text-align: center;
  font-style: italic;
  color: #808080;
}
.CSVImporter_ColumnDragCard__cardValue + div {
  margin-top: 0;
}
.CSVImporter_ColumnDragCard[data-shadow=true] > .CSVImporter_ColumnDragCard__cardValue[data-header=true] {
  color: rgba(128, 128, 128, 0.25);
}`, "",{"version":3,"sources":["webpack://./components/csv_import/fields-step/ColumnDragCard.scss","webpack://./theme.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,oBCQa;EDPb,gBCJe;EDKf,yCAAA;EACA,eAAA;AADF;AAGE;EACE,YAAA;EAGA,kBAAA;AAHJ;AAME;EACE,gBAAA;EACA,mBCnBQ;EDoBR,gBAAA;EACA,YAAA;EACA,iBAAA;AAJJ;AAOE;EACE,iCAAA;EACA,cCpBQ;ADeZ;AAQE;EACE,mBC/BQ;EDgCR,gBAAA;EACA,6BAAA;AANJ;AASE;EACE,wCAAA;EACA,WCvCM;ADgCV;AAUE;EACE,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,cCxCiB;ADgCrB;AAUI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBCvDM;EDwDN,cAAA;AARN;AAWI;EACE,cAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AATN;AAaE;EAEE,WCvEM;AD2DV;AAeE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;AAbJ;AAeI;EACE,kBAAA;EACA,kBAAA;EACA,cC5Ee;AD+DrB;AAgBI;EACE,aAAA;AAdN;AAkBE;EACE,gCAAA;AAhBJ","sourcesContent":["@import '../../../theme.scss';\n\n.CSVImporter_ColumnDragCard {\n  position: relative;\n  z-index: 0; // reset stacking context\n  padding: 0.5em 0.75em;\n  border-radius: $borderRadius;\n  background: $controlBgColor;\n  box-shadow: 0 1px 1px rgba(#000, 0.25);\n  cursor: default;\n\n  &[data-draggable='true'] {\n    cursor: grab;\n\n    // avoid triggering scroll on iOS Safari (needed despite preventDefault also being used)\n    touch-action: none;\n  }\n\n  &[data-dummy='true'] {\n    border-radius: 0;\n    background: $fillColor;\n    box-shadow: none;\n    opacity: 0.5;\n    user-select: none;\n  }\n\n  &[data-error='true'] {\n    background: rgba($errorTextColor, 0.25);\n    color: $textColor;\n  }\n\n  &[data-shadow='true'] {\n    background: $fillColor;\n    box-shadow: none;\n    color: rgba($textColor, 0.25); // reduce text\n  }\n\n  &[data-drop-indicator='true'] {\n    box-shadow: 0 1px 2px rgba(#000, 0.5);\n    color: $fgColor;\n  }\n\n  &__cardHeader {\n    margin-top: -0.25em;\n    margin-right: -0.5em;\n    margin-bottom: 0.25em;\n    margin-left: -0.5em;\n    height: 1.5em; // sized to be covered by small button\n    font-weight: bold;\n    color: $textSecondaryColor;\n\n    & > b {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 100%;\n      background: $fillColor;\n      line-height: 1; // centered by parent anyway\n    }\n\n    > var {\n      display: block;\n      margin-bottom: -1px;\n      width: 1px; // non-zero size for reader\n      height: 1px;\n      overflow: hidden;\n    }\n  }\n\n  &__cardPaper[data-draggable='true']:hover &__cardHeader,\n  &__cardPaper[data-dragged='true'] &__cardHeader {\n    color: $fgColor;\n  }\n\n  &__cardValue {\n    margin-top: 0.25em;\n    overflow: hidden;\n    line-height: 1.25em; // might not be inherited from main content\n    font-size: 0.75em;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    &[data-header='true'] {\n      text-align: center;\n      font-style: italic;\n      color: $textSecondaryColor;\n    }\n\n    & + div {\n      margin-top: 0;\n    }\n  }\n\n  &[data-shadow='true'] > &__cardValue[data-header='true'] {\n    color: rgba($textSecondaryColor, 0.25); // reduce text\n  }\n}\n","$fgColor: #000;\n$fillColor: #f0f0f0;\n$controlBorderColor: #808080;\n$controlBgColor: #fff;\n\n$invertedTextColor: #f0f0f0;\n$invertedBgColor: #404040;\n\n$textColor: #202020;\n$textSecondaryColor: #808080;\n$textDisabledColor: rgba($textColor, 0.5);\n$errorTextColor: #c00000;\n$titleFontSize: 1.15em; // relative to body font\n\n$borderRadius: 0.4em;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
